(() => {
  const grid = document.querySelector('[data-stock-order-grid]');
  if (!grid || window.Shopify?.designMode) return;
  const current = new URL(location.href);
  if (current.searchParams.has('filter.v.availability') || !['', 'created-descending'].includes(current.searchParams.get('sort_by') || '')) return;
  const cards = element => [...element.querySelectorAll(':scope > [data-card-product-id]')];
  if (Number(grid.dataset.pages) <= 1) {
    const items = cards(grid);
    grid.append(...items.filter(item => item.dataset.available === 'true'), ...items.filter(item => item.dataset.available !== 'true'));
    grid.dataset.stockOrder = 'complete';
    return;
  }
  const size = Number(grid.dataset.pageSize);
  const page = Number(grid.dataset.currentPage);
  if (!Number.isInteger(size) || size < 1 || !Number.isInteger(page) || page < 1) return;
  const cache = new Map();
  const getPage = async (available, number) => {
    const key = available + ':' + number;
    if (cache.has(key)) return cache.get(key);
    const url = new URL(current);
    url.searchParams.set('section_id', grid.dataset.sectionId);
    url.searchParams.set('filter.v.availability', available ? '1' : '0');
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('page', String(number));
    const response = await fetch(url, { headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error('collection response');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = doc.querySelector('[data-stock-order-grid]');
    if (!result || !Number.isInteger(Number(result.dataset.total))) throw new Error('collection metadata');
    if (cards(result).some(item => item.dataset.available !== String(available))) throw new Error('availability filter unavailable');
    cache.set(key, result);
    return result;
  };
  const range = async (available, start, count) => {
    const result = [];
    while (count > 0) {
      const number = Math.floor(start / size) + 1;
      const offset = start % size;
      const take = Math.min(count, size - offset);
      const items = cards(await getPage(available, number)).slice(offset, offset + take);
      if (items.length !== take) throw new Error('collection changed');
      result.push(...items); start += take; count -= take;
    }
    return result;
  };
  const reorder = async () => {
    grid.setAttribute('aria-busy', 'true');
    try {
      // Offset each partition independently so stock ordering also crosses page boundaries.
      const first = await getPage(true, 1);
      const available = Number(first.dataset.total);
      const total = Number(grid.dataset.total);
      const start = (page - 1) * size;
      const count = Math.max(0, Math.min(size, total - start));
      if (available > total) throw new Error('collection changed');
      const inStock = Math.max(0, Math.min(count, available - start));
      const items = await range(true, start, inStock);
      items.push(...await range(false, Math.max(0, start - available), count - inStock));
      if (new Set(items.map(item => item.dataset.cardProductId)).size !== count) throw new Error('duplicate products');
      if (!grid.isConnected) return;
      grid.replaceChildren(...items);
      grid.dataset.stockOrder = 'complete';
      document.dispatchEvent(new CustomEvent('may-london:products-rendered'));
    } catch (_) { grid.dataset.stockOrder = 'unavailable'; }
    finally { grid.removeAttribute('aria-busy'); }
  };
  reorder();
})();
